import React from 'react'
import styles from "./Dialog.module.scss"
import HTMLContent from "../../HTMLContent"
import ButtonsHolder from '../../Button/ButtonsHolder'
import Button from '../../Button'
import Scroll from '../../Scroll/Scroll'

const Dialog = (props) => {

    const { show, size, header, scroll = true, children, className, onClose, html, buttonText = "close" } = props

    return (
        <>
        { show && 
            <div className={`${styles.Dialog} ${className}`} >
                <div className={`modal-container ${styles.modal_container} ${size ? styles[size] : ''}`}>
                    {scroll && <Scroll className={`modal_content ${styles.modal_content}`}>
                        { header && <h2>{header}</h2>}
                        { html && <HTMLContent html={html} /> }
                        { children || <></> }

                        { onClose && 
                            <ButtonsHolder orientation="right">
                                <Button text={buttonText} onClick={onClose} />
                            </ButtonsHolder>
                        }
                    </Scroll>}
                    {!scroll && <>
                        { header && <h2>{header}</h2>}
                        { html && <HTMLContent html={html} /> }
                        { children || <></> }

                        { onClose && 
                            <ButtonsHolder orientation="right">
                                <Button text={buttonText} onClick={onClose} />
                            </ButtonsHolder>
                        }
                        </>
                    }
                </div>
            </div>
        }
        </>
    )

}

export default Dialog;
